namespace Gordic.Adm.WebControls {
    export interface IGPrirazeneRoleAgendyISZR {
        cnt: GContent,
        ginIszrFunrol: number,
        isPovolenaEvidenceOP: boolean,
        permission: {
            edit: boolean,
            create: boolean
        },
        agendy: {
            agenda: string | null | undefined,
            nazev: string | null | undefined,
            priz_aiseo: number | null | undefined,
            priz_isep: number | null | undefined,
            priz_aisc: number | null | undefined,
            priz_aiseop: number | null | undefined, 
            pocet_role: number | null | undefined
        }[],
        role: {
            agenda: string | null | undefined,
            role: string | null | undefined,
        }[]
    }

    export class GPrirazeneRoleAgendyISZR {
        options: IGPrirazeneRoleAgendyISZR;
        actions: GActionList;
        grid: JQuery<HTMLElement>;
        editMode: boolean;

        constructor(options: IGPrirazeneRoleAgendyISZR) {
            this.options = options;
            this.editMode = false;
            this.createActions();
        }

        createTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-agendy-role-iszr",
                    title: this.options.ginIszrFunrol == 1 ? "jres:33000584" : "jres:33000585", //RC 33000585 : Agendy ISZR
                    opened: true,
                    locked: true,
                    group: { id: "_tab-agendy-role-iszr" },
                    menuBar: [
                        {
                            action: this.actions.actAddISZRRole,
                            favorite: true
                        },
                        {
                            action: this.actions.actEditRole,
                            visible: this.options.ginIszrFunrol == 1,
                            favorite: true
                        },
                        {
                            action: this.actions.actRemoveAgenda,
                            favorite: true
                        }
                    ]
                },
                init: (tab: JQuery<HTMLElement>) => { this.createGrid(tab) }
            }
        }

        createGroup(): IGTabGroupOptions {
            return {
                id: "_tab-agendy-role-iszr",
                caption: this.options.ginIszrFunrol == 1 ? "jres:33000584" : "jres:33000585"
            }
        }

        changeEdit(editMode: boolean) {
            this.editMode = editMode;
            this.actions.actAddISZRRole?.update({ enabled: editMode })
            this.actions.actEditRole?.update({ enabled: editMode })
            this.actions.actRemoveAgenda?.update({ enabled: editMode })
        }

        getPrirazeneAgendy() {
            return this.options.agendy;
        }

        getPrirazeneRole() {
            return this.options.role;
        }

        private createGrid(tab: JQuery<HTMLElement>) {
            this.grid = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: this.createGridFormat()
            }).ggridroweditor({
                beforeStart: (ev, info) => {
                    if (this.editMode == false)
                        return false;
                },
                commit: (ev, info) => {
                    var index = this.options.agendy.findIndex(el => el.agenda == info.cellInfo.data.agenda)
                    if (index != -1)
                        this.options.agendy[index] = info.cellInfo.data;
                    else
                        this.options.agendy.push(info.cellInfo.data);
                },
            })
            this.grid.ggrid("setData", this.options.agendy)
        }

        private createGridFormat(): Gordic.Data.GridFormat {
            var gridFormat = new Gordic.Data.GridFormat()
                .addTextColumn({
                    name: "agenda",
                    caption: "jres:33000587", //RC 33000587 : Agenda
                }).addTextColumn({
                    name: "nazev",
                    caption: "jres:32131029"
                })
            if (this.options.ginIszrFunrol == 1) {
                gridFormat.addTextColumn({
                    name: "role",
                    caption: "jres:33000588", //RC 33000588 : Role (n/z)
                    cellTemplate: (item) => {
                        var pocetPrirazenych = this.options.role.filter((el) => {
                            return el.agenda == item.agenda
                        }).length;
                        return "{0}/{1}".format(pocetPrirazenych, item.pocet_role)
                    }
                })
            }
               gridFormat.addBooleanColumn({
                   name: "priz_aiseo",
                   caption: "jres:33000589", //RC 33000589 : Přístup do AISEO
                   width: 70,
                   editor: {
                       widget: "gcheck",
                       options: {
                           model: function (op, dto, opt) {
                               switch (op) {
                                   case "apply":
                                       $(this).gfield("setValue", dto.priz_aiseo == 1);
                                       break;
                                   case "collect":
                                       dto.priz_aiseo = $(this).gfield("getValue") == true ? 1 : 0;
                                       break;
                               }
                           }
                       }
                   }
                }).addBooleanColumn({
                   name: "priz_isep",
                    caption: "jres:33000590", //RC 33000590 : Přístup do ISEP
                    width: 70,
                    editor: {
                        widget: "gcheck",
                        options: {
                            model: function (op, dto, opt) {
                                switch (op) {
                                    case "apply":
                                        $(this).gfield("setValue", dto.priz_isep == 1);
                                        break;
                                    case "collect":
                                        dto.priz_isep = $(this).gfield("getValue") == true ? 1 : 0;
                                        break;
                                }
                            }
                        }
                    }
                }).addBooleanColumn({
                   name: "priz_aisc",
                    caption: "jres:33000591", //RC 33000591 : Příznak do AISC
                    width: 70,
                    editor: {
                        widget: "gcheck",
                        options: {
                            model: function (op, dto, opt) {
                                switch (op) {
                                    case "apply":
                                        $(this).gfield("setValue", dto.priz_aisc == 1);
                                        break;
                                    case "collect":
                                        dto.priz_aisc = $(this).gfield("getValue") == true ? 1 : 0;
                                        break;
                                }
                            }
                        }
                    }
                })
            if (this.options.isPovolenaEvidenceOP == true) {
                gridFormat.addBooleanColumn({
                    name: "priz_aiseop",
                    caption: "jres:33001017", //RC 33001017 : Přístup do EOP
                    width: 70,
                    editor: {
                        widget: "gcheck",
                        options: {
                            model: function (op, dto, opt) {
                                switch (op) {
                                    case "apply":
                                        $(this).gfield("setValue", dto.priz_aiseop == 1);
                                        break;
                                    case "collect":
                                        dto.priz_aiseop = $(this).gfield("getValue") == true ? 1 : 0;
                                        break;
                                }
                            }
                        }
                    }
                })
            }
            return gridFormat;
        }

        private createActions() {
            this.actions = new GActionList({
                actAddISZRRole: {
                    icon: "gi-plus",
                    enabled: false,
                    caption: "jres:33000248",
                    run: () => {
                        this.addAgenda();
                    }
                },
                actCloseDialog: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        this.closeCnt(ev);
                    }
                },
                actAddISZRRoleAdd: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.addAgendaToGrid(ev);
                    }
                },
                actEditRole: {
                    caption: "jres:33000593", //RC 33000593 : Poovlené role
                    icon: "gi-pencil",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.editRole();
                    }
                },
                actEditRoleOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.editRoleOk(ev);
                    }
                },
                actRemoveAgenda: {
                    caption: "jres:33000596", //RC 33000596 : Odebrat agendu
                    icon: "gi-bin",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.removeAgenda();
                    }
                }
            });
        }

        private addAgenda() {
            var form = new Gordic.Forms.Form({ name: "agenda-add-form", customClass: "agenda-add-form" })
                .addRow("jres:29808385").addField("gselectbox", Gordic.Prefabs.Select.szrsage(), {
                    name: "agenda",
                    dropdown: false,
                    multi: true,
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    itemWidth: ""
                })

            this.options.cnt.dialogs.simpleForm("jres:33000586", form, null, { //RC 33000586 : Přidat agendu ISZR
                height: 200,
                commandBar: [
                    {
                        action: this.actions.actAddISZRRoleAdd,
                        primary: true
                    }, 
                    {
                        action: this.actions.actCloseDialog
                    }
                ]
            }) 
        }

        private closeCnt(ev) {
            var cnt = $.content(ev.target);
            cnt.close();
        } 

        private addAgendaToGrid(ev) {
            var cnt = $.content(ev.target);
            var form = cnt.findForms("agenda-add-form");
            if (form.gform("isValid")) {
                var agendy = cnt.findFields("agenda").gfield("getValue");
                if (agendy.length > 0) {
                    agendy.forEach((agenda) => {
                        var index = this.options.agendy.findIndex(el => el.agenda == agenda.agenda)
                        if (index == -1) {
                            if (this.options.ginIszrFunrol == 1) {
                                new Gordic.Data.Readers.Szrsagr().getData({ agenda: agenda.agenda }).done((result) => {
                                    this.options.agendy.push({
                                        agenda: agenda.agenda,
                                        nazev: agenda.nazev,
                                        priz_aiseo: 0,
                                        priz_isep: 0,
                                        priz_aisc: 0,
                                        priz_aiseop: 0,
                                        pocet_role: result.length
                                    })
                                    this.grid.ggrid("setData", this.options.agendy);
                                })
                            } else {
                                this.options.agendy.push({
                                    agenda: agenda.agenda,
                                    nazev: agenda.nazev,
                                    priz_aiseo: 0,
                                    priz_isep: 0,
                                    priz_aisc: 0,
                                    priz_aiseop: 0,
                                    pocet_role: 0
                                })
                                this.grid.ggrid("setData", this.options.agendy);
                            }
                        }
                    })
                }
                cnt.close();
            }
        }

        private editRole() {
            var agenda = this.grid.ggrid("activeRow");
            if (agenda != null) {
                var form = new Gordic.Forms.Form()
                    .addRow("jres:33000593").addField("gselectbox", Gordic.Prefabs.Select.szrsagr(), {
                        name: "role",
                        multi: true,
                        itemWidth: "",
                        serverFilters: {
                            agenda: agenda.agenda
                        }
                    })
                    .addField("gdummyfield", {
                        name: "agenda"
                    })

                this.options.cnt.dialogs.simpleForm("jres:33000593", form, {
                    role: this.options.role.filter((role) => { return role.agenda = agenda.agenda }).map(el => ({ agenda: el.agenda, agendova_role: el.role })),
                    agenda: agenda.agenda
                }, {
                    height: 200,
                    commandBar: [
                        {
                            action: this.actions.actEditRoleOk,
                            favorite: true,
                            primary: true
                        },
                        {
                            action: this.actions.actCloseDialog,
                        }
                    ]
                })
            }
        }

        private editRoleOk(ev) {
            var cnt = $.content(ev.target);
            // Ulozeni rolí do pole rolí
            var selectedRole = cnt.findFields("role").gfield("getValue");
            var selectedAgenda = cnt.findFields("agenda").gfield("getValue");
            for (var i = 0; i < this.options.role.length; i++) {
                var obj = this.options.role[i];
                if (obj.agenda == selectedAgenda) {
                    this.options.role.splice(i, 1);
                    i--;
                }
            }
            selectedRole.forEach((item) => {
                this.options.role.push({ agenda: selectedAgenda, role: item.agendova_role })
            })
            // Aktualizace poctu zatrzenych 
            this.grid.ggrid("setData", this.options.agendy)
            cnt.close();
        }

        private removeAgenda() {
            var agenda = this.grid.ggrid("activeRow");
            if (agenda != null) {
                var index = this.options.agendy.findIndex(ag => ag.agenda == agenda.agenda);
                this.options.agendy.splice(index, 1);
                for (var i = 0; i < this.options.role.length; i++) {
                    if (this.options.role[i].agenda == agenda.agenda) {
                        this.options.role.splice(i, 1);
                        i--;
                    }
                }
                this.grid.ggrid("setData", this.options.agendy);
            }
        }
    }
}